/**
 * Append a badge icon to a React component
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './BadgeIcon.module.scss'

const cx = classnames.bind(styles)

const badges = {
  crown: {
    pos: 'bottom-left',
    component: (iconStyle) => (
      <FontAwesomeIcon icon={['fas', 'crown']} className='font-inherit' style={iconStyle} />
    )
  }
}

/**
 * Appends an icon badge to a component
 * @param {Object} props.children The component to append the badge
 * @param {String} props.options The options for the badge
 * @param {String} props.type The type of the badge
 */
const BadgeIcon = ({ children, options, type }) => {
  if (!children) {
    return null
  }

  const badge = badges[type]

  const badgeClasses = cx(
    'badge',
    {
      [`badge-${badge?.pos}`]: badge?.pos
    })

  return (
    <div className={cx('badge-container')}>
      {children}
      <div className={badgeClasses}>
        {badge?.component()}
      </div>
    </div>
  )
}

BadgeIcon.defaultProps = {
  children: null,
  type: null
}

BadgeIcon.propTypes = {
  children: PropTypes.node,
  options: PropTypes.object,
  type: PropTypes.oneOf([null, 'crown'])
}

export default BadgeIcon
